import template from 'url-template'

import { curry, compose } from 'ramda';
import makeTemplateGetter from '@aspectus/resource-template-url-getter';
import {
  defaultDataTransformer,
  jsonTransformer,
} from '@packages/resource-commons';

const filtersGetterBase = makeTemplateGetter('{/filters*}/');

const filtersGetter = parameters => filtersGetterBase(parameters).slice(1) || null

const partGetter = (name, prefix) => {
  const base = makeTemplateGetter(`${prefix}{/${name}}`);
  return parameters => {
    const result = base(parameters);
    return result === prefix ? null : result;
  };
};

const pageGetter = partGetter('page', 'page');
const labelGetter = makeTemplateGetter('{label}');
const categoryGetter = makeTemplateGetter('{category}');
const getParametersGetter = makeTemplateGetter('{?limit,offset}');

const orderMap = {
  label: labelGetter,
  category: categoryGetter,
  filters: filtersGetter,
  pagination_offset: getParametersGetter,
  page: pageGetter,
}

const initOrder = {
  path: [
    'prefix',
    'filters',
  ],
}
const USELESS_SIGNS = [
  // FIXME: Fuck that! Url formatter should be changed, not by just
  // stripping the "useless" parts.
  { exp: /([\w-]+=)/g, value: '' },
  { exp: /;/, value: '' },
  { exp: /%2C/g, value: ',' },
  { exp: /filters/g, value: '' },
  { exp: /\/\//img, value: '/' },
]

export const urlCleaner = url => {
  // eslint-disable-next-line no-return-assign
  USELESS_SIGNS.forEach(({ exp, value }) => url = url.replace(exp, value))
  return url
}

export function sortObjKeysAlphabetically(obj) {
  return Object.keys(obj).sort((a, b) => a.localeCompare(b)).reduce((result, key) => {
    result[key] = obj[key];
    return result;
  }, {});
}

export const sorter = obj => {
  if (!obj) return obj
  Object.keys(obj).forEach(k => {
    obj[k].sort((a, b) => a.localeCompare(b))
  })
  obj = sortObjKeysAlphabetically(obj)
  return obj
}

export const urlGetter = curry(([prefix, postfix], { path, query = [] }, p) => {
  p.filters = sorter(p.filters)
  const base = { prefix, postfix }
  const pathParts = path.reduce((acc, x, i) => {
    acc[i] = orderMap[x] ? orderMap[x](p) : base[x]
    return acc
  }, Array.from({ length: path.length }, () => null))
  const queryParams = query.reduce((acc, x) => {
    acc.push(orderMap[x](p))
    return acc
  }, [])
  const result = (`${pathParts.filter(x => null !== x).join('/')}/`).replace(/\/\//img, '/').replace(/\/\//img, '/').replace(/%2C/g, ',')
  return urlCleaner(result) + queryParams.join('')
});

export const friendlyUrlGenerator = (url, resource, order = initOrder) => resource
  .url(urlGetter(url, order))
  .transform(jsonTransformer)
  .transform(defaultDataTransformer)
